<template>
  <club-layout>
    <blue-panel-player-info
      :invoice="invoice"
      :balance="balance"
      :insurance="insurance"
      :description="description"
    />
    <div id="container">
      <table-blue-player-transfers :cashIn="coinIn" :cashOut="coinOut" :transfers="transfers" />
    </div>
  </club-layout>
</template>

<script>
  import BluePanelPlayerInfo from './panels/PanelBlue/PanelBluePlayerInfo';
  import TableBluePlayerTransfers from './tables/TableBluePlayerTransfers.vue';
  import TableBlueSummary from './tables/TableBlue/TableBlueSummary';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'PageClubInvoiceTransfers',
    components: {
      BluePanelPlayerInfo,
      TableBluePlayerTransfers,
      TableBlueSummary,
    },
    data() {
      return {
        invoice: null,
        balance: null,
        insurance: null,
        description: '',
        transfers: [],
        coinIn: 0,
        coinOut: 0,
      }
    },
    computed: {
      ...mapGetters(['invoices']),
    },
    methods: {
      ...mapActions(['getInvoiceTransfers']),
    },
    async created() {
      const playerId = parseInt(this.$route.params.id, 10);
      const player = this.invoices.filter(invoice => invoice.playerId === playerId)[0]
      if (!player) {
        return;
      }
      this.invoice = player.invoice;
      this.balance = player.balance;
      this.insurance = player.insurance;
      this.description = player.description || '';
      this.transfers = (await this.getInvoiceTransfers({ playerId })).transfers;
      this.coinIn = this.transfers
        .filter(item => item.action === 'CREATE' || item.action === 'DEPOSIT')
        .map(item => item.amount)
        .reduce((c, n) => c + n, 0);
      this.coinOut = this.transfers
        .filter(item => item.action === 'REMOVE' || item.action === 'WITHDRAW')
        .map(item => item.amount)
        .reduce((c, n) => c + n, 0);
    },
  }
</script>

<style scoped>
  #container {
    margin-top: 20px;
  }
</style>
